import {
  aliceBlueColor,
  blackPantherColor,
  checkboxColor,
  figmaTitleColor,
  melonColor,
  redShadowColor,
  SeashellColor,
  stoneColdGrayColor,
  strongRedColor,
  warmPinkColor,
  white,
} from "../../../config/ColorObj";

export const importPopupStyles = {
  dialog: {
    width: "70%",
    borderRadius: "12px",
  },
  dialogContent: {
    backgroundColor: aliceBlueColor,
  },
  outerGrid: {
    alignItems: "flex-start",
    flexWrap: { xs: "wrap", md: "nowrap" },
  },
  contentBox: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: "10px 5px",
    justifyContent: "flex-start",
  },
  labelRow: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  labelInner: {
    display: "flex",
    alignItems: "center",
  },
  asteriskLabel: {
    fontSize: 18,
    fontWeight: 500,
    color: strongRedColor,
  },
  selectFileLabel: {
    fontSize: 17,
    fontWeight: 450,
    color: blackPantherColor,
    whiteSpace: "nowrap",
  },
  attachFileBox: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  fileNameRow: {
    display: "flex",
    alignItems: "center",
  },
  fileNameText: {
    fontSize: 17,
    fontWeight: 400,
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
    maxWidth: "800px",
    flex: "1 1 auto",
    color: figmaTitleColor,
    cursor: "pointer",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  actionGrid: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-end",
  },
  hintTextGrid: {
    display: "flex",
    justifyContent: "flex-start",
  },
  hintText: {
    fontSize: "14px",
    color: stoneColdGrayColor,
    textAlign: "right",
  },
  actionButtonsGrid: {
    display: "flex",
    justifyContent: "flex-end",
  },
  actionButtonsBox: {
    display: "flex",
    gap: 1,
    justifyContent: "flex-end",
  },
  clearButton: {
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
    minWidth: "120px",
    height: "35px",
    borderColor: melonColor,
    color: strongRedColor,
    backgroundColor: SeashellColor,
    boxShadow: "0 3px 6px rgba(248, 248, 248, 0.1)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: warmPinkColor,
      borderColor: strongRedColor,
      color: redShadowColor,
      transform: "translateY(-2px)",
      boxShadow: "0 6px 12px rgba(248, 248, 248, 0.2)",
    },
  },
  validateButton: {
    color: white,
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
    transition: "all 0.2s",
    minWidth: "150px",
    height: "35px",
    "&:hover": {
      backgroundColor: checkboxColor,
      transform: "translateY(-2px)",
    },
  },
  closeIconButton: {
    position: "absolute",
    right: 8,
    top: 8,
    color: (theme) => theme.palette.grey[500],
  },
  uploadIcon: {
    color: white,
  },
};

export const tableHeaderButtonStyles = {
  exportButton: {
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
    transition: "all 0.2s",
    minWidth: "120px",
    height: "35px",
    "&:hover": {
      transform: "translateY(-2px)",
    },
  },
  importButton: {
    color: white,
    borderRadius: 2,
    textTransform: "none",
    fontWeight: 600,
    transition: "all 0.2s",
    minWidth: "150px",
    height: "35px",
    "&:hover": {
      backgroundColor: checkboxColor,
      transform: "translateY(-2px)",
    },
  },
  paper: {
    borderRadius: 2,
    p: { xs: 2, sm: 4 },
    boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
    maxWidth: "auto",
    margin: "auto",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonGroup: {
    display: "flex",
    gap: 15,
  },
  searchRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
  },
  searchInput: {
    padding: "6px 10px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    width: "230px",
  },
};
